"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSortedBusinessVerticals = exports.getDropdownDefaultLabel = exports.getLookupValuesForDropdown = void 0;
/**
 *
 * @param field - name of the lookup field
 * @param lookups - object received from DB with all values
 * @returns - array of objects with label + value to be used in a dropdown component
 */

var getLookupValuesForDropdown = function getLookupValuesForDropdown(field, lookups) {
  if (!lookups) {
    throw Error("Error parsing dropdown values: lookup values missing");
  }

  var values = lookups[field];

  if (!values) {
    throw Error("Error parsing dropdown values for ".concat(field, ": missing or invalid values."));
  }

  try {
    var items = [];
    Object.keys(values).forEach(function (key) {
      var item = {
        value: key,
        label: values[key]
      };
      items.push(item);
    });
    return items;
  } catch (error) {
    throw Error("Error parsing dropdown values for ".concat(field, ": ").concat(error));
  }
};
/**
 * This is a hack for the issue where dropdowns don't show
 * the default value Label, they show the Value instead.
 * Until that's fixed, we are handpicking the Label from the list
 * in order to show it in the placeholder attr. Yes, hacky.
 * @param items - all dropdown items
 * @param value - selected value
 * @returns the matching label for the selected value
 */


exports.getLookupValuesForDropdown = getLookupValuesForDropdown;

var getDropdownDefaultLabel = function getDropdownDefaultLabel(items, value) {
  var option = items.find(function (op) {
    return op.value === value;
  });

  if (option) {
    return option.label;
  }

  return value;
};
/**
 * @param values - dropdown values for Business Vertical
 * @returns the same but alphabetically sorted
 */


exports.getDropdownDefaultLabel = getDropdownDefaultLabel;

var getSortedBusinessVerticals = function getSortedBusinessVerticals(values) {
  try {
    return values.sort(function (a, b) {
      return a.label > b.label ? 1 : -1;
    });
  } catch (error) {
    throw Error("Error sorting business vertical values: ".concat(error));
  }
};

exports.getSortedBusinessVerticals = getSortedBusinessVerticals;